import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import Swal from 'sweetalert2'
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import {BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput, BFormCheckbox, VBToggle, VBTooltip} from "bootstrap-vue";

export default {
  name: "Products",
  mixins: [mixins],
  components: {
    Loading,ExcelDownload,
    BTooltip, BButton, BCard, BTable, BCollapse, BFormCheckbox,BFormGroup, BFormInput
  },
  directives: {
    'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
  },
  data() {
    return {
      url: 'admin/products',
      excelUrl: 'admin/reports/special-export',
      widgets: [
        'categories'
      ],
      productExcels: [], 
      showModal: false,  
      productTitle: null,  
      isFilter: 0,  
      stores: [],
      excelDownloalId: 0,
      warehouseTotals: [],
      fields: [
        {
          key: 'id',
          label: 'شناسه'
        },
        {
          key: 'title',
          label: 'عنوان'
        },
        {
          key: 'main_price',
          label: 'قیمت'
        },
        {
          key: 'main_store_balance',
          label: 'موجودی(مرکزی)'
        },
        {
          key: 'categories',
          label: 'دسته بندی ها'
        },
        {
          key: 'status',
          label: 'وضعیت'
        },
        {
          key: 'status',
          label: 'وضعیت'
        },
        {
          key: 'approved_at',
          label: 'وضعیت تایید'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
        // {
        //   key: 'logs',
        //   label: 'لاگ انبار گردانی'
        // },
        {
          key: 'send_bale',
          label: 'ارسال به بله'
        },
        {
          key: 'edit',
          label: 'ویرایش'
        },
        {
          key: 'delete',
          label: 'حذف'
        },
        {
          key: 'excell',
          label: 'چاپ بارکد'
        }
      ],
      showingCategories: [],
      varietyLogs: null,
      disabledBaleBtn: false,
      statusOptions: [{
        value: 'available',
        name: 'موجود',
      },
        {
          value: 'soon',
          name: 'بزودی',
        },
        {
          value: 'out_of_stock',
          name: 'ناموجود',
        },
        {
          value: 'draft',
          name: 'پیش نویس',
        },
        {
          value: 'presale',
          name: 'پیش فروش',
        },
        {
          value: '',
          name: 'همه',
        },
      ],
      store_taking_status: [
        {
          name: 'انبار گردانی شده',
          value: 'stocked'
        },
        {
          name: 'انبار گردانی نشده',
          value: 'not_stocked'
        },
        {
          name: 'همه',
          value: 'all'
        },
      ],
      approveOptions: [{
        name: 'تایید شده',
        value: '1'
      },
        {
          name: 'تایید نشده',
          value: '0'
        },
        {
          name: 'همه',
          value: ''
        },
      ],
      filter: {
        id: '',
        title: '',
        category_id: '',
        status: '',
        approved_at: '',
        store_id: null,
        store_taking_status: ''
      },
    }
  },
  computed: {  
    totalBalance() {  
      if (this.productExcels) {  
        let total = 0;  
        this.productExcels.forEach(productExcel => {  
          if (productExcel && productExcel[3]) {  
            productExcel[3].forEach(item => {  
              total += item.balance;  
            });  
          }  
        });  
        return total;  
      }  
      return 0;  
    }  
  }, 
  mounted() {
    this.loadStores();
    this.loadItems().then(response => {
      window.ok = response.data.data.statusCounts
      for (let [key, count] of Object.entries(response.data.data.statusCounts)) {
        this.statusOptions = this.statusOptions.map(statusOption => {
          if (statusOption.value == key) {
            statusOption.name = statusOption.name + ` (${count})`;
          }
          return statusOption
        })
      }
    })
  },
  watch: {
    'filter.status': function (newVal) {
      if (typeof newVal === 'string' || typeof newVal === 'number') {
        this.filter.status = this.statusOptions.find(item => {
          return item.value == newVal
        })
      }
    },
    'filter.approved_at': function (newVal) {
      if (typeof newVal === 'string' || typeof newVal === 'number') {
        this.filter.approved_at = this.approveOptions.find(item => {
          return item.value == newVal
        })
      }
    },
    'filter.category_id': function (newVal) {
      this.onLoadHandlers.push(() => {
        if (typeof newVal === 'string' || typeof newVal === 'number') {
          this.filter.category_id = this.widgetData.categories.find(item => {
            return item.id == newVal
          })
        }
      })
    },
  },
  methods: {
    async loadStores(){
      try {
          const response = await this.$axios.get("admin/stores");
          this.stores = response.data.data.stores;
      } catch (e) {
          this.$root.notify(e);
      } 
    },
    async sendToBale(id){
      try {
          this.disabledBaleBtn = true;
          const response = await this.$axios.post(`admin/products/send-to-bale/${id}`);
          this.$root.notify(response.data.message, "success");
      } catch (e) {
          this.$root.notify(e);
      } finally {
          this.disabledBaleBtn = false;
      } 
    },
    calculateWarehouseTotals() {  
      if (this.productExcels) {  
        const totals = {};

        this.productExcels.forEach(productExcel => {  
          if (productExcel && productExcel[3]) {  
            productExcel[3].forEach(item => {  
              const label = item.label;  
              const store_id = item.store_id;  
              if (!totals[label]) {  
                totals[label] = { label: label,store_id: store_id, total: 0 };
              }  
              totals[label].total += item.balance; 
            });  
          }  
        });  

        this.warehouseTotals = Object.values(totals);  
      }  
    },  
    async downloadExcell(product_id) {
      const params = { ids: [product_id] }; 
      this.excelDownloalId = product_id;
      const response = await this.$axios(`admin/products_excels`, {  
        params: params,  
      });  
      this.productExcels = response.data.data.data;  
      this.calculateWarehouseTotals();
      this.showModal = true;  
    },  
    closeModal() {  
      this.showModal = false;  
    },  
    goToPrintVarieties(product_id, store_id) {  
      this.showModal = false;  
      this.$router.push(`/admin/print-varieties?ids=${product_id}&store_id=${store_id}`);  
    }, 
    showCat(p) {
      if (!this.showingCategories.includes(p)) {
        this.showingCategories.push(p)
      }
    },
    hideCat(p) {
      this.showingCategories = this.showingCategories.filter(_p => {
        return _p !== p;
      })
    },
    async filterItem(page = 1) {
      this.isFilter = 1;
      this.searchParams = {
        search1: this.filter.id,
        searchBy1: 'id',
        search2: this.filter.title,
        searchBy2: 'title',
        search3: this.filter.category_id != null ? this.filter.category_id.id : '',
        searchBy3: 'category_id',
        search4: this.filter.status ? this.filter.status.value : '',
        searchBy4: 'status',
        search5: this.filter.approved_at ? this.filter.approved_at.value : '',
        searchBy5: 'approved_at',
        store_id: this.filter.store_id ? this.filter.store_id.id : "",
        status: this.filter.store_taking_status ? this.filter.store_taking_status.value : '',
      }
    },
    async approveForm(e, product) {
      const el = e.target;
      let bounding = el.getBoundingClientRect();
      this.$nextTick(() => {
        const swalForm = document.querySelector('body.swal2-toast-shown .swal2-container.swal2-center');
        swalForm.style.left = bounding.x + 'px'
        swalForm.style.top = bounding.y + 'px'
        swalForm.style.right = 'unset'
      })
      if (!this.hasPermission('approved_product')) {
        return;
      }
      const approveOrDeny = (approve) => {
        return this.$axios.post(`admin/products/${product.id}/${approve ? 'approve' : 'disapprove'}`)
            .then(response => {
              return response
            })
            .catch(error => {
              const message = error.data.message ? error.data.message : `درخواست با مشکل مواجه شد: ${error.data.message}`
              Swal.showValidationMessage(message)
            })
      }

      const value = await Swal.fire({
        title: 'تایید یا رد محصول شماره ' + product.id,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `تایید`,
        denyButtonText: `رد`,
        cancelButtonText: `لغو عملیات`,
        toast: true,
        preConfirm: (result) => {
          return approveOrDeny(true)
        },
        preDeny: (result) => {
          return approveOrDeny(false)
        }
      }).then((result) => {
        if (result.isConfirmed) {
          product.approved_at = this.moment()
          Swal.fire({
            title: `محصول با موفقیت تایید شد`,
            confirmButtonText: `باشه`,
          })
        } else if (result.isDenied) {
          product.approved_at = null
          Swal.fire({
            title: `محصول با موفقیت رد شد`,
            confirmButtonText: `باشه`,
          })
        }
      })
    },
    async showVarietyLogs(product_id,title) {
      this.productTitle = title;
      const response = await this.$axios("admin/stores/store-taking-logs/" + product_id);  
      this.varietyLogs = response.data.data.logs;  
    },  
  }
}
